import { CreateRoadmapActionDTO, RoadmapAction } from '../types/roadmapAction.type';
import { ApiRepository } from './main repository/api.repository';

export namespace RoadmapActionService {
  const BASE_API = `${window.globalConfiguration.api.base}/v1/roadmapActions`;

  export const createOne = async (createRoadmapActionDTO: CreateRoadmapActionDTO): Promise<RoadmapAction> => {
    return ApiRepository.Core().post<CreateRoadmapActionDTO, RoadmapAction>(BASE_API, createRoadmapActionDTO);
  };

  export const getKeys = async (): Promise<
    Record<string, { label: string; comment: string | null; isTransformationPath: boolean }>
  > => {
    return ApiRepository.Core().get<
      Record<string, { label: string; comment: string | null; isTransformationPath: boolean }>
    >(`${BASE_API}/keys`);
  };
}
